import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

export const Bar = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: var(--spacing-03) 0;
  margin-bottom: var(--layout-01);
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
`;
export const ArchiveButton = styled(Button)`
  font-weight: var(--font-weight-bold);
  border: transparent;
`;

export const StyledLink = styled(NavLink)`
  margin-top: var(--spacing-03);
`;
